/**
 * @file 右下浮窗
 * @author 陈恩浩
 */

import React, { Component } from 'react'
import './index.scss'

class Float extends Component {
  constructor(props) {
    super(props)
    this.state = {
      status: false,
    }
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll)
  }

  componentWillUnmount() {
    // window.removeEventListener('scroll', this.handleScroll)
  }

  handleScroll = (event) => {
    //滚动条高度
    let scrollTop = document.documentElement.scrollTop || document.body.scrollTop; //滚动条滚动高度
    if (scrollTop > 1) {
      this.setState({ status: true })
    } else {
      this.setState({ status: false })
    }
  }
  handerUper = () => {
    window.scrollTo(0, 0)
  }

  render() {
    let { status } = this.state
    return (
      <ul className="float-ul">
        <li></li>
        <li>
          <img
            alt="qrcode"
            className="float-qrcode"
            src="//cdn.ihatoo.com/hatu-official/public/servise_qrcode.png"
          />
        </li>
        <li>
          <span
            className="float-phone"
          >+86-571-88162929</span>
        </li>
        <li style={{ opacity: status ? 1 : 0 }} onClick={this.handerUper}></li>
      </ul>
    )
  }
}

export default Float
